// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"96134bd5","453":"c1c1e9e0","490":"162b2e5e"}[chunkId] + ".chunk.js";
};